import * as React from 'react';
import { useState } from 'react';
import type { ReservationState } from '@digitalopsdev/serviceops-reservations-components/dist/EditReservation/types';
import { CreateRateSnapshotPanel } from './CreateRateSnapshotModal';
import { ApplyRateSnapshotPanel } from './ApplyRateSnapshotModal';

type Tab = 'create' | 'apply';

interface Props {
    reservationState: ReservationState;
    initialTab?: Tab;
    onClose: () => void;
}

export function SnapshotsModal({ reservationState, initialTab = 'apply', onClose }: Props) {
    const [activeTab, setActiveTab] = useState<Tab>(initialTab);

    return (
        <div className="modal show d-block" tabIndex={-1} style={{ backgroundColor: 'rgba(0,0,0,0.5)' }}>
            <div className="modal-dialog modal-xl">
                <div className="modal-content">
                    <div className="modal-header pb-0">
                        <ul className="nav nav-tabs card-header-tabs flex-grow-1 border-bottom-0" role="tablist">
                            <li className="nav-item" role="presentation">
                                <button
                                    type="button"
                                    role="tab"
                                    aria-selected={activeTab === 'apply'}
                                    className={`nav-link ${activeTab === 'apply' ? 'active' : ''}`}
                                    onClick={() => setActiveTab('apply')}
                                >
                                    Apply Snapshot
                                </button>
                            </li>
                            <li className="nav-item" role="presentation">
                                <button
                                    type="button"
                                    role="tab"
                                    aria-selected={activeTab === 'create'}
                                    className={`nav-link ${activeTab === 'create' ? 'active' : ''}`}
                                    onClick={() => setActiveTab('create')}
                                >
                                    Create Snapshot
                                </button>
                            </li>
                        </ul>
                        <button type="button" className="btn-close" onClick={onClose}></button>
                    </div>
                    {activeTab === 'create' ? (
                        <CreateRateSnapshotPanel
                            key="create"
                            reservationState={reservationState}
                            onClose={onClose}
                        />
                    ) : (
                        <ApplyRateSnapshotPanel
                            key="apply"
                            reservationState={reservationState}
                            onClose={onClose}
                        />
                    )}
                </div>
            </div>
        </div>
    );
}
